import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
    selector: 'mapp-unauthorized-message',
    templateUrl: './unauthorized-message.component.html',
    styleUrls: ['./unauthorized-message.component.scss'],
    standalone: false,
})
export default class UnauthorizedMessageComponent {
    @Input() buttonLabel: string;

    @Input() isModal: boolean;

    /**
     *
     */
    @Input() set content(value: string) {
        this.sanitizedContent = this.sanitizeHtml(value || this.defaultText);
    }

    @Output() buttonClick: EventEmitter<void> = new EventEmitter();

    defaultText =
        "You don't have the necessary permissions to access this tool. If you believe you should have access, please contact our support team for assistance at <a href='mailto:AILabs@mmc.com'>AILabs@mmc.com</a>";

    sanitizedContent: SafeHtml | null = this.defaultText;

    visible: boolean;

    /**
     *
     * @param sanitizer
     */
    constructor(private readonly sanitizer: DomSanitizer) {}

    /**
     *
     * @param html
     */
    private sanitizeHtml(html: string): SafeHtml {
        return this.sanitizer.bypassSecurityTrustHtml(html);
    }

    /**
     *
     */
    open() {
        this.visible = true;
    }

    /**
     *
     */
    close() {
        this.visible = false;
    }

    /**
     *
     */
    handleButtonClick() {
        this.buttonClick.emit();
    }
}
